import { ComponentType, Portal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetConfig,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { BehaviorSubject, Subject, from } from 'rxjs';
import { bottomSheetDefaultConfig } from 'src/app/config/bottom-sheet.config';

@Injectable({
  providedIn: 'root'
})
export class BottomSheetService {
  private contents: BehaviorSubject<Portal<any>[]> = new BehaviorSubject<Portal<any>[]>([]);
  private portal$ = new Subject<Portal<any> | null>();

  constructor(
    private bottomSheet: MatBottomSheet
  ) { }

  get portal() {
    return from(this.portal$);
  }

  open<T, D = any, R = any>(template: ComponentType<T>, config?: MatBottomSheetConfig<D>, portal?: Portal<any>): MatBottomSheetRef<T, R> {
    if (portal) {
      this.contents.next([portal]);
      this.portal$.next(portal);
    }
    return this.bottomSheet.open(template, { ...bottomSheetDefaultConfig, ...config })
  }

}
